import axios from 'axios';

const PageService = {
    pageCache: {},
    getCached: function (id) {
        if ('prerenderedJSON' in window && id in window.prerenderedJSON) {
            return window.prerenderedJSON[id];
        }

        var encid = encodeURIComponent(id);
        if (encid in this.pageCache) {
            return this.pageCache[encid];
        }

        var ls = localStorage.getItem("lthub_cached_page_" + encid);
        if (ls && ls !== "undefined") {
            try {
                var jls = JSON.parse(ls);
                this.pageCache[encid] = jls;
                return jls;
            }
            catch(e){
                console.error(e);
                return null;
            }
        }
        return null;
    },
    getPage: function(request) {
        var self = this;
        const encUri = encodeURIComponent(request.id);
        /*if ('prerenderedJSON' in window && request.id in window.prerenderedJSON) {
            return new Promise((resolve, reject) => {
                resolve({ "data": { "data": window.prerenderedJSON[request.id] } });
            });
        }*/

        return axios.get("api/pages/" + encUri, { params: request }, { withCredentials: true }).then((response) => {
            if (response.status === 200) {
                self.pageCache[encUri] = response.data.data;
                localStorage.setItem("lthub_cached_page_" + encUri, JSON.stringify(response.data.data));
            }
            return response;
        });
    },
    getList: (request, options = {}) => {
        return axios.get("api/pages/list", { params: request, ...options }, { withCredentials: true, ...options });
    },
    getListSimple: (request) => {
        return axios.get("api/pages/picklist", { params: request }, { withCredentials: true });
    },
    getListVersions: (request) => {
        return axios.get("api/pages/restorelist", { params: request }, { withCredentials: true });
    },
    getAutocomplete: (request) => {
        return axios.get("api/pages/autocomplete", { params: request }, { withCredentials: true });
    },
    updatePage: (request) => {
        return axios.put("api/pages", request, { withCredentials: true });
    },
    approvePage: (request) => {
        return axios.put("api/pages/approve", request, { withCredentials: true });
    },
    restorePage: (request) => {
        return axios.put("api/pages/restore", request, { withCredentials: true });
    },
    revertPage: (request) => {
        return axios.put("api/pages/revert", request, { withCredentials: true });
    },
    deletePage: (request) => {
        return axios.delete("api/pages/" + request.id, {}, { withCredentials: true });
    },
    autocomplete: (area, term, offset) => {
        return axios.get(`api/pages/autocomplete/${area}/${term}`, { offset }, { withCredentials: true });
    },
};

export default PageService;